<template>
  <!-- 日期时间类（datepicker/rangepicker/monthpicker/monthrangepicker/timepicker/timerangepicker）：
       picker/showTime/format/valueFormat -->
  <a-row :gutter="16">
    <DateFormatConfig :config="config" />
  </a-row>
</template>

<script setup lang="ts">
import DateFormatConfig from '../DateFormatConfig.vue';

defineProps<{ config: any }>();
</script>
